export default __webpack_public_path__ + "static/media/logo-cinco-white.1727ebde.svg";